import { Alert, CircularProgress, Modal, Snackbar, Box, FormControl, InputLabel } from "@mui/material";
import { useState } from "react";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import servEquipamentos from "../../../services/login/servEquipamentos";
import { style as modalStyle } from "../../../components/Loading/Loading";
import "./style.css"
import { WhiteInput } from "../../../components/Inputs/InputText";
import { useSelector } from "react-redux";


const SolicitarCancelamento = ({ setOpenPopup, recordForEdit, pesquisar }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [openAlertWindow, setOpenAlertWindow] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [mensagemCancelamento, setMensagemCancelamento] = useState("");
    const [severity, setSeverity] = useState("warning");
    const user = useSelector(state => state.user);

    const handleCloseAlert = (event, reason) => {
        if (reason  === 'clickaway') {
            setOpenAlertWindow(false);
        }

        setOpenAlertWindow(false);
    }

    const solicitarCancelamento = async () => {
        if (recordForEdit === null) {
            return;
        }

        try {
            setIsLoading(true);

            if(mensagemCancelamento.trim() === '') {
                setOpenAlertWindow(true);
                setAlertMessage("O motivo do cancelamento deve ser preenchido.");
                setIsLoading(false);
                return;
            }

            if(mensagemCancelamento.length < 15) {
                setOpenAlertWindow(true);
                setAlertMessage("O motivo do cancelamento deve conter no mínimo 15 caracteres.");
                setIsLoading(false);
                return;
            }

            if(mensagemCancelamento.length > 2000) {
                setOpenAlertWindow(true);
                setAlertMessage("O motivo do cancelamento deve conter no máximo 2000 caracteres.");
                setIsLoading(false);
                return;
            }
            
            await servEquipamentos.SolicitarCancelamento(recordForEdit?.Id || recordForEdit?.row?.Id, mensagemCancelamento, user.name, user.codigoUsuario);
            
            setIsLoading(false);
            setOpenAlertWindow(true);
            setSeverity("success")
            setAlertMessage("Equipamento cancelado com sucesso.");

            setTimeout(() => {
                setOpenPopup(false);
                pesquisar();
            }, [1500]);

        } catch (err) {
            setIsLoading(false);

            setSeverity("error");
            setAlertMessage(err.response.data.Message);
            return setOpenAlertWindow(true);
        }
        
    }

    return (
        <div style={{ width: "100%", height: "20%" }}>
            <h4>
                Você deseja cancelar a homologação do equipamento? <br />
                Após o cancelamento, o equipamento só poderá ser acessado para visualização e não estará disponível para uso.
            </h4>
            <div>
                <FormControl variant="outlined" style={{ margin: '20px 0px 20px 35px', width: '90%' }}>
                    <InputLabel htmlFor="equipamentos-motivoinativacao" shrink style={{ color: "#B8B8B8" }} >
                        Motivo de cancelamento
                    </InputLabel>
                    <WhiteInput 
                            fullWidth
                            multiline
                            minRows={4}
                            placeholder="Insira um motivo" 
                            type="text"
                            id="equipamentos-motivoinativacao" 
                            value={mensagemCancelamento}
                            onChange={(e) => setMensagemCancelamento(e.target.value)} 
                        />
                </FormControl>
            </div>
            <div style={{
                padding: "10px 45px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "20px"
            }}>
                <BlueHoverButton onClick={solicitarCancelamento}>Solicitar cancelamento</BlueHoverButton>
            </div>

            <Snackbar open={openAlertWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseAlert}> 
                    <Alert onClose={handleCloseAlert} severity={severity} sx={{ width: '100%' }}>
                        {alertMessage}
                    </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    )
}

export { SolicitarCancelamento };